<template>
  <span>
    <div class="inline-block mr-1">
      <researcher-avatar-cluster :researchers="voters" small />
    </div>
    <div class="inline-block font-weight-medium">
      {{ voters.map((r) => r.firstName()).join(' & ') }}
    </div>
  </span>
</template>

<script>
import ResearcherAvatarCluster from '@/components/Common/ResearcherAvatarCluster';
import { Researcher } from '@/models';
import { typeHelpers } from '@/modules';

export default {
  name: 'LastVotersClusterPrefix',
  components: { ResearcherAvatarCluster },
  props: {
    voters: {
      type: Array,
      required: true,
      validator: (val) => typeHelpers.isArrayOfType(val, Researcher),
    },
  },
};
</script>

<style lang="scss" scoped>
.inline-block {
  display: inline-block;
  vertical-align: middle;
}
</style>
